import { useEffect } from 'react';
import Lenis from 'lenis';

let lenisInstance: Lenis | null = null;

export function useLenis(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const isMobile = window.innerWidth < 769;
    if (isMobile) return;

    const lenis = new Lenis({
      lerp: 1,
      wheelMultiplier: 0.7,
      touchMultiplier: 0.5,
      infinite: false,
    });

    lenisInstance = lenis;

    const raf = (time: number) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisInstance = null;
    };
  }, [enabled]);
}

export function getLenis() {
  return lenisInstance;
}
